<template>
  <BittsCard title-text="Sharing Controls" class="sharing-controls-card">
    <div class="sharing-controls-card__content">
      <BittsSwitch
        v-model="greenfieldSharingSetting"
        label="Enable Greenfield Sharing for Non Admins"
        description="Allow non admin users access to Share All setting"
      />
      <BittsButton
        text="Save Changes"
        size="small"
        class="mt-16"
        :loading="isSaving"
        :disabled="!hasSettingChanged"
        @click="onSaveSettings"
      />
    </div>
  </BittsCard>
</template>

<script setup lang="ts">
import { BittsButton, BittsCard, BittsSwitch } from '@crossbeam/bitts';

import { computed, onMounted, ref } from 'vue';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';
import { useFlashesStore } from '@/stores';

const initialGreenfieldSharingSetting = ref(false);
const greenfieldSharingSetting = ref(false);
const flashesStore = useFlashesStore();
const hasSettingChanged = computed(() => {
  return (
    initialGreenfieldSharingSetting.value !== greenfieldSharingSetting.value
  );
});

const isSaving = ref(false);

async function onSaveSettings() {
  isSaving.value = true;
  const { error } = await crossbeamApi.PUT(
    '/v0.1/organization/settings/sharing-controls',
    {
      body: { is_greenfield_setting_enabled: greenfieldSharingSetting.value },
    },
  );
  if (error) {
    flashesStore.addErrorFlash({
      message: 'Failed to save sharing changes',
    });
    captureException(error);
  } else {
    flashesStore.addSuccessFlash({ message: 'Sharing changes saved' });
    initialGreenfieldSharingSetting.value = greenfieldSharingSetting.value;
  }
  isSaving.value = false;
}

onMounted(async () => {
  const { data, error } = await crossbeamApi.GET(
    '/v0.1/organization/settings/sharing-controls',
  );
  if (error) {
    flashesStore.addErrorFlash({
      message: 'Failed to load sharing settings',
    });
    captureException(error);
    return;
  }
  if (!data) return;
  initialGreenfieldSharingSetting.value = data?.is_greenfield_setting_enabled;
  greenfieldSharingSetting.value = data?.is_greenfield_setting_enabled;
});
</script>
<style scoped lang="pcss">
.sharing-controls-card__content {
  @apply px-16 pb-16;
}
:deep(.bitts-card__title) {
  @apply text-lg text-neutral-text-strong font-bold;
}
</style>
